import React from 'react';
import { INTENT_LABEL } from '../data/keywordsCentrosRehabilitacion';

/**
 * Tabla compacta de keywords con barras de volumen + chips de KD y intent.
 * Diseñada para mostrar top 10-15 keywords.
 */
export default function KeywordTable({ keywords, maxRows = 12 }) {
  if (!keywords || keywords.length === 0) return null;
  const maxVol = Math.max(...keywords.map((k) => k.vol), 1);
  const rows = keywords.slice(0, maxRows);

  const kdColor = (kd) => {
    if (kd < 20) return 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30';
    if (kd < 40) return 'bg-amber-500/15 text-amber-300 border-amber-500/30';
    return 'bg-red-500/15 text-red-300 border-red-500/30';
  };

  return (
    <div
      className="overflow-x-auto bg-slate-900/40 border border-slate-800 rounded-2xl"
      data-testid="keyword-table"
    >
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-800 text-xs uppercase tracking-wider text-slate-500">
            <th className="text-left px-4 py-3 font-semibold">Palabra clave</th>
            <th className="text-right px-4 py-3 font-semibold hidden sm:table-cell">Intent</th>
            <th className="text-right px-4 py-3 font-semibold">Volumen/mes</th>
            <th className="text-right px-4 py-3 font-semibold">KD%</th>
            <th className="text-right px-4 py-3 font-semibold hidden md:table-cell">CPC</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((k, i) => {
            const widthPct = Math.max(8, (k.vol / maxVol) * 100);
            const intent = INTENT_LABEL[k.intent] || INTENT_LABEL.I;
            return (
              <tr
                key={k.kw}
                className="border-b border-slate-800/60 hover:bg-slate-900/60 transition-colors"
                data-testid={`keyword-row-${i}`}
              >
                <td className="px-4 py-3 text-slate-100">
                  <div className="flex items-center gap-3">
                    <span className="text-slate-600 text-xs font-mono w-5 text-right">{i + 1}</span>
                    <span className="font-medium">{k.kw}</span>
                  </div>
                </td>
                <td className="text-right px-4 py-3 hidden sm:table-cell">
                  <span
                    className={`inline-block text-[10px] font-bold px-2 py-0.5 rounded border ${intent.color}`}
                    title={intent.label}
                  >
                    {k.intent}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <div className="hidden md:block w-24 bg-slate-950 rounded-full h-2 overflow-hidden border border-slate-800">
                      <div
                        className="h-full bg-gradient-to-r from-emerald-700 to-emerald-400 rounded-full"
                        style={{ width: `${widthPct}%` }}
                      />
                    </div>
                    <span className="text-white font-mono text-sm w-14 text-right">{k.vol.toLocaleString('es-CL')}</span>
                  </div>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className={`inline-block text-xs font-semibold px-2 py-0.5 rounded border ${kdColor(k.kd)}`}>
                    {k.kd}
                  </span>
                </td>
                <td className="text-right px-4 py-3 text-slate-400 font-mono text-xs hidden md:table-cell">
                  ${k.cpc.toFixed(2)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
